export default "/_next/static/images/97ee8ccdfa036be3c23c254345cfe5a1.png";